// Training and Class Categories
// Centralized enum to ensure consistency across all components

export enum TrainingCategory {
  OPEN_MAT = 'Open Mat',
  COMPETITION_TRAINING = 'Competition Training',
  SEMINAR = 'Seminar',
  SELF_DEFENSE = 'Self-Defense',
  OTHER = 'Other'
}

export enum ClassCategory {
  TRAINING = 'Training',
  COMPETITION_TRAINING = 'Competition Training',
  SEMINAR = 'Seminar',
  SELF_DEFENSE = 'Self-Defense',
  OPEN_MAT = 'Open Mat'
}

// Array versions for easy iteration in components
export const TRAINING_CATEGORIES = Object.values(TrainingCategory);
export const CLASS_CATEGORIES = Object.values(ClassCategory);

// Type definitions for TypeScript
export type TrainingCategoryType = keyof typeof TrainingCategory;
export type ClassCategoryType = keyof typeof ClassCategory;

// Translation key mapping for training categories
export const TRAINING_CATEGORY_TRANSLATION_KEYS: Record<TrainingCategory, string> = {
  [TrainingCategory.OPEN_MAT]: 'open_mat',
  [TrainingCategory.COMPETITION_TRAINING]: 'competition_training',
  [TrainingCategory.SEMINAR]: 'seminar',
  [TrainingCategory.SELF_DEFENSE]: 'self_defense',
  [TrainingCategory.OTHER]: 'other'
};

// Legacy category mappings for backward compatibility
export const LEGACY_TRAINING_CATEGORY_MAPPINGS: Record<string, string> = {
  'Sparring': 'sparring',
  'Technique Work': 'technique_work',
  'Strength & Conditioning': 'strength_conditioning',
  'Recovery': 'recovery',
  'Mental Training': 'mental_training',
  'Strategy Session': 'strategy_session',
  'Video Analysis': 'video_analysis',
  'Private Lesson': 'private_lesson',
  'Private Class': 'private_class',
  'Workshop': 'workshop',
  'Grading': 'grading',
  'Open Competition': 'open_competition',
  'Team Training': 'team_training',
  'Cross Training': 'cross_training',
  'Flexibility': 'flexibility',
  'Mobility': 'mobility',
  'Cardio': 'cardio',
  'Fundamentals Class': 'fundamentals_class',
  'Group Class': 'group_class'
};

// Utility function to get translation key for any training category
export function getTrainingCategoryTranslationKey(category: string): string {
  // First check if it's one of our enum values
  if (Object.values(TrainingCategory).includes(category as TrainingCategory)) {
    return TRAINING_CATEGORY_TRANSLATION_KEYS[category as TrainingCategory];
  }
  
  // Then check legacy mappings
  if (LEGACY_TRAINING_CATEGORY_MAPPINGS[category]) {
    return LEGACY_TRAINING_CATEGORY_MAPPINGS[category];
  }
  
  // Fallback: convert to snake_case
  return category.toLowerCase().replace(/\s+/g, '_');
}
